import React, { createContext, useContext, useState } from 'react'

const ProgressContext = createContext(0)
const SetProgressContext = createContext(() => {})

export const useSetProgressContext = () => {
  return useContext(SetProgressContext)
}

export const useProgressContext = () => {
  return useContext(ProgressContext)
}

const ProgressProvider = ({ children }) => {
  const [progressState, setProgressState] = useState(0)
  
return (
  <SetProgressContext.Provider value={setProgressState}>
    <ProgressContext.Provider value={progressState}>
      {children}
    </ProgressContext.Provider>
  </SetProgressContext.Provider>
  )
}

export default ProgressProvider
